// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hs-0";
export var animationContainer = "_hs-1";
export var itemPrice = "_hs-a";
export var itemizedContent = "_hs-9";
export var itemizedHeader = "_hs-7";
export var itemizedRow = "_hs-8";
export var itemizedSection = "_hs-6";
export var modalContent = "_hs-2";
export var orderName = "_hs-3";
export var refundOption = "_hs-4";
export var refundOptionsContainer = "_hs-5";
export var shippingLabel = "_hs-b";
export var totalRow = "_hs-c";